import { makeEntityScaffold } from '@classpass/saga-tools';
import {
  ReservationsResponse,
  ReservationCancellationType,
  ReservationStatus,
} from '@classpass/protobuf-definitions/lib/web/models/partners/reservation';

import URLS from 'constants/urls';
import { transformKeysToCamelCase } from 'helpers/core';

export const handler = ({ httpClient }, venueId, scheduleId) => {
  const endpoint = URLS.venue.roster(venueId, scheduleId);
  return httpClient
    .get(endpoint)
    .then(response => transformKeysToCamelCase(ReservationsResponse.fromJSON(response.data)))
    .then(({ reservations }) =>
      reservations.map(attendee => {
        const { attendanceStatus, cancellationType, reservationStatus, firstName, lastName } = attendee;
        return Object.assign(attendee, {
          // coerce falsy (0|1) to legit bools but convert undefined to null
          attendanceStatus: attendanceStatus === undefined ? null : !!attendanceStatus,
          isClassCancelled: cancellationType === ReservationCancellationType.CLASS_CANCELLED,
          isLateCancel: [
            ReservationCancellationType.USER_CANCELLED,
            ReservationCancellationType.USER_LATE_CANCEL,
          ].includes(cancellationType),
          isLateCancelWaived: cancellationType === ReservationCancellationType.USER_LATE_CANCEL_WAIVE,
          isQueued: reservationStatus === ReservationStatus.QUEUED,
          fullName: `${firstName} ${lastName}`,
        });
      })
    );
};

export default makeEntityScaffold('SAGA.API.VENUE.ROSTER', handler, { defaultKey: 2 });
